import PropTypes from "prop-types";
import { PageHeader } from "@evertrue/et-components";
import OutreachNav from "../components/outreach-nav";
import OutreachEmailComponent from "../components/outreach-email-component";

const OutreachController = ({ view }) => {
  // Mock data for drafts, scheduled, sent, etc.
  const drafts = [
    {
      id: "5d3qmne77v32r8l4phyuksl2x",
      snippet:
        "This is a preview with 100 character limit. This is a preview with 100 character limit. This is a preview with 100 character limit.",
      subject: "Email Subject",
      body: "This is a preview with 100 character limit but it's longer because it's actually the body of the email. This is a preview with 100 character limit but it's longer because it's actually the body of the email. This is a preview with 100 character limit but it's longer because it's actually the body of the email. This is a preview with 100 character limit but it's longer because it's actually the body of the email.",
      to: [{ constituent_id: 123456, name: "Virginia Osbourne", email: "test@test.com" }],
      cadence: { step_number: 1, day_number: 4, journey_name: "Introduction", journey_id: 125 },
      thankview: { personal_video_id: 123456 },
      email_template: { id: 1234, name: "Template Name" },
      created_at: 1727073998000,
    },
    {
      id: "4d3qmne77v32r8l4phyuksl2x",
      snippet: "This is a preview with 100 character limit",
      subject: "Email Subject2",
      body: "This is a preview with 100 character limit but it's longer because it's actually the body of the email.",
      to: [{ constituent_id: 123456, name: "Jon Snow", email: "test@test.com" }],
      cadence: { step_number: 1, day_number: 4, journey_name: "Introduction cadence", journey_id: 126 },
      thankview: { personal_video_id: 123456 },
      email_template: { id: 1234, name: "Template2" },
      created_at: 1726987598000,
    },
  ];

  return (
    <>
      <PageHeader title="Outreach" />
      <OutreachNav tab={view} />
      {view === "email" && <OutreachEmailComponent drafts={drafts} />}
    </>
  );
};

OutreachController.propTypes = {
  view: PropTypes.string,
};

export default OutreachController;
